/**
 * this file contains only ROUTE url factory helpers which are used in both App and E2E scenarios
 *
 * If you need to generate some URL with some additional functionality, THIS IS NOT THE PLACE FOR IT.
 * -> create that helper in some shared/* module
 */

import { API_VERSION, ENDPOINT } from '../environment'

type RouteParamID = ':id'

export const ADMIN_USER_VIEW_BASE = 'admin-team'

export const links = {
  auth: {
    home: () => `/login`,
    notAuthorized: () => `/not-authorized`,
    loginAdfs: (endpoint = ENDPOINT) => `${endpoint}/api/login/adfs`,
    logout: () => `/auth/logout`,
    forgotPassword: () => `/auth/forgot-password`,
    resetPassword: (id: number | string | RouteParamID, code: string) => `/auth/reset-password/${id}/${code}`,
  },
  reports: {
    home: (base = '/') => `${base}reports`,
    personGoals: {
      home: (base = '/reports/personGoals') => `${base}`,
      detail: (id: number | string, base = '/reports/personGoals') => `${base}/${id}`,
      report: (base = `${ENDPOINT}/${API_VERSION}/report/people-goal/excel`) => base,
    },
    idp: {
      home: (base = '/reports/idp') => `${base}`,
      detail: (id: number | string, base = '/reports/idp') => `${base}/${id}`,
      report: (base = `${ENDPOINT}/${API_VERSION}/report/idp/excel`) => base,
    },
    reviews: {
      home: (base = '/reports/reviews') => `${base}`,
      detail: (id: number | string, base = '/reports/reviews') => `${base}/${id}`,
      report: (base = `${ENDPOINT}/${API_VERSION}/report/review/excel`) => base,
      reportFull: (base = `${ENDPOINT}/${API_VERSION}/report/review/excel-full`) => base,
      reportMidYearMeeting: (base = `${ENDPOINT}/${API_VERSION}/report/review/meetingMidYear/excel`) => base,
      reportEndYearMeeting: (base = `${ENDPOINT}/${API_VERSION}/report/review/meeting/excel`) => base,
      reportEndYearCalculation: (base = `${ENDPOINT}/${API_VERSION}/report/review/calculation/excel`) => base,
      reportEndYearCalibration: (base = `${ENDPOINT}/${API_VERSION}/report/review/calibration/excel`) => base,
      reportManagerAssessmentOverall: (
        base = `${ENDPOINT}/${API_VERSION}/report/review/managerAssessmentOverallTemplate/excel`
      ) => base,
    },
    devGoals: {
      home: (base = '/reports/dev-goals') => `${base}`,
      detail: (id: number | string, base = '/reports/dev-goals') => `${base}/${id}`,
      report: (base = `${ENDPOINT}/${API_VERSION}/report/people-development-goal/excel`) => base,
    },
    perfGoals: {
      home: (base = '/reports/perf-goals') => `${base}`,
      report: (base = `${ENDPOINT}/${API_VERSION}/report/people-performance-goal/excel`) => base,
    },
  },

  persons: {
    personHistoryReport: (base = `${ENDPOINT}/${API_VERSION}/persons/excelHistory`) => base,
  },
  admin: {
    home: () => `/admin`,
    dashboard: (base = '/admin') => `${base}/dashboard`,
    organizations: {
      home: (base = '/admin') => `${base}/organizations`,
      detail: (id: number | string, base = '/admin/organizations') => `${base}/${id}`,
      edit: (id: number | string, base = '/admin/organizations') => `${base}/${id}/edit`,
      create: (base = '/admin/organizations') => `${base}/create`,
      report: (base = `${ENDPOINT}/${API_VERSION}/organization-units/report`) => base,
    },
    persons: {
      home: (base = '/admin') => `${base}/persons`,
      detail: (id: number | string, base = '/admin/persons') => `${base}/${id}`,
      edit: (id: number | string, base = '/admin/persons') => `${base}/${id}/edit`,
      create: (base = '/admin/persons') => `${base}/create`,
      report: (base = `${ENDPOINT}/${API_VERSION}/persons/report`) => base,
      massExelHistoryReport: (base = `${ENDPOINT}/${API_VERSION}/persons/excellFilterHistory`) => base,
      fullReport: (base = `${ENDPOINT}/${API_VERSION}/persons/full-report`) => base,
      mergeProfiles: (base = '/admin') => `${base}/persons/merge`,
    },

    blogs: {
      home: (base = '/admin') => `${base}/blogs`,
      edit: (id: number | string, base = '/admin/blogs') => `${base}/${id}/edit`,
      detail: (id: number | string, base = '/admin/blogs') => `${base}/${id}`,
      create: (base = '/admin/blogs') => `${base}/create`,
      postAttachment: (id: number) => `${ENDPOINT}/${API_VERSION}/blog/${id}/attachment`,
    },
    import: {
      home: (base = '/admin') => `${base}/import`,
    },
    bonusPeriods: {
      home: (base = '/admin') => `${base}/bonus-periods`,
      detail: (id: number | string, base = '/admin/bonus-periods') => `${base}/${id}`,
      edit: (id: number | string, base = '/admin/bonus-periods') => `${base}/${id}/edit`,
      create: (base = '/admin/bonus-periods') => `${base}/create`,
    },
    mergeProfiles: {
      home: (base = '/admin') => `${base}/merge-profiles`,
    },
    adminActions: {
      home: (base = '/admin') => `${base}/admin-actions`,
    },
    divisionMapping: {
      home: (base = '/admin') => `${base}/department-division-mappings`,
    },
  },
  frontFace: {
    home: () => `/`,
    dashboard: () => `/dashboard`,
    allstars: {
      home: () => `/allstars`,
    },
    personal: {
      home_goals_legacy: (base = '/goals') => `${base}`,
      home_feedback_legacy: (base = '/feedback') => `${base}`,
      home_reviews_legacy: (base = '/reviews') => `${base}`,
      home_my_development_legacy: (base = '/my-development') => `${base}`,
      home_blog_legacy: (base = '/blog') => `${base}`,
      home: (base = '/') => `${base}personal`,
      goals: {
        home: (base = '/personal/') => `${base}goals`,
        home_legacy: () => `/goals/my`,
        myGoals: (base = '/personal/goals') => `${base}/my`,
        teamGoals: (base = '/personal/goals') => `${base}/team`,
        pdf: (id: number | string, bonusPeriodId: number, base = `${ENDPOINT}/${API_VERSION}`) =>
          `${base}/persons/${id}/goals/pdf?bonusPeriodId=${bonusPeriodId}`,
      },
      feedback: {
        home: (base = '/personal/') => `${base}feedback`,
        activity_legacy: (base = '/feedback/') => `${base}activity`,
        activity: (base = '/personal/feedback') => `${base}/activity`,
        archive: (base = '/personal/feedback') => `${base}/archive`,
        mentions: (base = '/personal/feedback') => `${base}/mentions`,
        requestFeedback: (base = '/personal/feedback') => `${base}/request-feedback`,
        provideFeedback: (base = '/personal/feedback') => `${base}/provide-feedback`,
      },
      reviews: {
        home: (base = '/personal/') => `${base}reviews`,
        MidYear: (base = '/personal/reviews') => `${base}/midYear`,
        EndYear: (base = '/personal/reviews') => `${base}/endYear`,
        OneToOne: (base = '/personal/reviews') => `${base}/one2one`,
        Probation: (base = '/personal/reviews') => `${base}/probation`,
        LeaveCompany: (base = '/personal/reviews') => `${base}/leaveCompany`,
        ChangePosition: (base = '/personal/reviews') => `${base}/changePosition`,
        Exit: (base = '/personal/reviews') => `${base}/exit`,
        MidYearNew: (base = '/personal/reviews') => `${base}/midYear`,
        EndYearNew: (base = '/personal/reviews') => `${base}/endYear`,
        overview: {
          home: (base = '/personal/reviews') => `${base}/overview`,
          detail: (base = '/personal/reviews', type: number | string, id: number | string) => `${base}/${type}/${id}`,
        },
        pdf: (
          id: number | string,
          reviewType?: number,
          bonusPeriodId?: number,
          base = `${ENDPOINT}/${API_VERSION}`
        ) => {
          const params: string[] = []
          if (reviewType !== undefined) params.push(`reviewType=${reviewType}`)
          if (bonusPeriodId !== undefined) params.push(`bonusPeriodId=${bonusPeriodId}`)
          return `${base}/persons/${id}/reviews/pdf${params.length ? '?' + params.join('&') : ''}`
        },
      },
      myDevelopment: {
        home: (base = '/personal/') => `${base}my-development`,
        current: (base = '/personal/my-development') => `${base}/current`,
        archive: (base = '/personal/my-development') => `${base}/archive`,
        export: (personId: number | string, base = `${ENDPOINT}/${API_VERSION}`) =>
          `${base}/persons/${personId}/idp/pdf`,
      },
      blog: {
        home: (base = '/personal/') => `${base}blog`,
      },
    },

    team: {
      home: (base = '/') => `${base}team`,
      my: (base = '/team') => `${base}/my`,
      myFormer: (base = '/team') => `${base}/my-former`,
      myTeamEvaluation: (base = '/team') => `${base}/my-evaluation`,
      exportGoals: (base = `${ENDPOINT}/${API_VERSION}/report/people-goal/excel?OnlyMyTeam=true`) => base,
      teamGoals: {
        home_legacy: (base = '/') => `${base}teamGoals`,
        home: (base = '/team') => `${base}/goals`,
      },
      teamReviews: {
        home: (base = '/team') => `${base}/reviews`,
        employee: {
          home: (base = '/team/reviews') => `${base}/employee`,
          detail: (base = '/team/reviews/employee', type: number | string, id: number | string) =>
            `${base}/${type}/${id}`,
        },
        perfGoals: (base = '/team/reviews') => `${base}/perf-goals`,
        coreValues: (base = '/team/reviews') => `${base}/core-values`,
        overall: (base = '/team/reviews') => `${base}/overall`,
        export: (
          personId: number | string,
          reviewType: number,
          bonusPeriodId: number | string,
          base = `${ENDPOINT}/${API_VERSION}`
        ) => `${base}/report/review/${reviewType}/${personId}/subordinates/excel?bonusPeriodId=${bonusPeriodId}`,
        pdf: (
          personId: number | string,
          reviewType: number,
          bonusPeriodId: number | string,
          base = `${ENDPOINT}/${API_VERSION}`
        ) => `${base}/persons/${personId}/team-reviews/${reviewType}/pdf?bonusPeriodId=${bonusPeriodId}`,
      },
      byUser: {
        home_legacy_old: (id: number | string, base = '') => `${base}userView/${id}`,
        goals_legacy_old: (id: number | string, base = `/userView/${id}`) => `${base}/goals`,
        review_legacy_old: (id: number | string, base = `/userView/${id}`) => `${base}/reviews`,
        feedbacks_legacy_old: (id: number | string, base = `/userView/${id}`) => `${base}/feedback`,
        teams_legacy_old: (id: number | string, base = `/userView/${id}`) => `${base}/team`,
        idp_legacy_old: (id: number | string, base = `/userView/${id}`) => `${base}/idp`,
        home_legacy: (id: number | string, base = '') => `${base}user-view/${id}`,
        goals_legacy: (id: number | string, base = `/user-view/${id}`) => `${base}/goals`,
        review_legacy: (id: number | string, base = `/user-view/${id}`) => `${base}/reviews`,
        feedbacks_legacy: (id: number | string, base = `/user-view/${id}`) => `${base}/feedback`,
        teams_legacy: (id: number | string, base = `/user-view/${id}`) => `${base}/team`,
        idp_legacy: (id: number | string, base = `/user-view/${id}`) => `${base}/idp`,

        homeFromAdmin: (id: number | string, base = `/${ADMIN_USER_VIEW_BASE}`) => `${base}/user-view/${id}`,
        home: (id: number | string, base = '/team') => `${base}/user-view/${id}`,
        goals: (id: number | string, base = `/team/user-view/${id}`) => `${base}/goals`,
        review: (id: number | string, base = `/team/user-view/${id}`) => `${base}/reviews`,
        reviewOverview: (id: number | string, base = `/team/user-view/${id}`) => `${base}/reviews/overview`,
        feedbacks: (id: number | string, base = `/team/user-view/${id}`) => `${base}/feedback`,
        teams: (id: number | string, base = `/team/user-view/${id}`) => `${base}/team`,
        idp: (id: number | string, base = `/team/user-view/${id}`) => `${base}/idp`,
        teamGoals: (id: number | string, base = `/team/user-view/${id}`) => `${base}/team-goals`,
        teamReviews: (id: number | string, base = `/team/user-view/${id}`) => `${base}/team-reviews`,
        regionalDirectorReviews: (id: number | string, base = `/team/user-view/${id}`) =>
          `${base}/regional-director-reviews`,
        functionalManagerReviews: (id: number | string, base = `/team/user-view/${id}`) =>
          `${base}/functional-manager-reviews`,
        former: (id: number | string, base = `/team/user-view/${id}`) => `${base}/former`,
      },
    },

    functional: {
      home: (base = '/') => `${base}functional`,
      team: (base = '/functional') => `${base}/team`,
      reviews: (base = '/functional') => `${base}/reviews`,
      employee: (base = '/functional/reviews') => `${base}/employee`,
      perfGoals: (base = '/functional/reviews') => `${base}/perf-goals`,
      coreValues: (base = '/functional/reviews') => `${base}/core-values`,
      overall: (base = '/functional/reviews') => `${base}/overall`,
      export: (
        personId: number | string,
        reviewType: number,
        bonusPeriodId: number | string,
        base = `${ENDPOINT}/${API_VERSION}`
      ) => `${base}/report/review/${reviewType}/${personId}/functionalManager/excel?bonusPeriodId=${bonusPeriodId}`,
      pdf: (
        personId: number | string,
        reviewType: number,
        bonusPeriodId: number | string,
        base = `${ENDPOINT}/${API_VERSION}`
      ) => `${base}/persons/${personId}/functional-reviews/${reviewType}/pdf?bonusPeriodId=${bonusPeriodId}`,
    },
    regional: {
      home: (base = '/') => `${base}regional`,
      team: (base = '/regional') => `${base}/team`,
      reviews: (base = '/regional') => `${base}/reviews`,
      employee: (base = '/regional/reviews') => `${base}/employee`,
      perfGoals: (base = '/regional/reviews') => `${base}/perf-goals`,
      coreValues: (base = '/regional/reviews') => `${base}/core-values`,
      overall: (base = '/regional/reviews') => `${base}/overall`,
      export: (
        personId: number | string,
        reviewType: number,
        bonusPeriodId: number | string,
        base = `${ENDPOINT}/${API_VERSION}`
      ) => `${base}/report/review/${reviewType}/${personId}/regionalDirector/excel?bonusPeriodId=${bonusPeriodId}`,
      pdf: (
        personId: number | string,
        reviewType: number,
        bonusPeriodId: number | string,
        base = `${ENDPOINT}/${API_VERSION}`
      ) => `${base}/persons/${personId}/regional-reviews/${reviewType}/pdf?bonusPeriodId=${bonusPeriodId}`,
    },

    functionalReviews: {
      home: (base = '/') => `${base}functional-manager-reviews`,
    },
    regionalReviews: {
      home: (base = '/') => `${base}regional-manager-reviews`,
    },
  },
  common: {
    blogs: {
      getAttachment: (attachmentUrl: string, base = `${ENDPOINT}/`) => `${base}${attachmentUrl}`,
    },
  },
  personProfile: {
    home: () => `/person-profile`,
  },
  misc: {
    notFound: () => `/not-found`,
  },
}



// WEBPACK FOOTER //
// ./src/app/app.links.ts